import React, { Component } from "react";
import { Layout, Form, Input, Select, Button, Table, Tag, message, Card } from "antd";
import {
  createLogRetrievalRequestApi,
  fetchLogRetrievalRequestsApi
} from "../../common/api";
import {
  buildLogRetrievalRequestPayload,
  createLogRetrievalRequestId,
  formatLogRetrievalTarget,
  logRetrievalStatusMeta
} from "../../common/log-retrieval-request";
import "./style.scss";

const { Option } = Select;

const DAYS_OPTIONS = [
  { label: "最近一天", value: 1 },
  { label: "最近三天", value: 3 },
  { label: "最近 7 天", value: 7 }
];

export function logRetrievalTaskHref(taskId) {
  return `#/s3-log-detail?tasks=${encodeURIComponent(taskId)}`;
}

const PLATFORM_OPTIONS = [
  { label: "所有平台", value: "all" },
  { label: "Android", value: "android" },
  { label: "iOS", value: "ios" }
];

class PushPage extends Component {
  state = {
    targetType: "deviceId",
    targetValue: "",
    days: 3,
    platform: "all",
    loading: false,
    historyLoading: false,
    history: []
  };

  componentDidMount() {
    this.loadHistory();
  }

  loadHistory = async () => {
    this.setState({ historyLoading: true });
    try {
      const history = await fetchLogRetrievalRequestsApi({ limit: 100 });
      this.setState({ history: Array.isArray(history) ? history : [] });
    } catch (error) {
      console.error("Failed to load retrieval work items", error);
    } finally {
      this.setState({ historyLoading: false });
    }
  };

  handleCreate = async () => {
    const { targetType, targetValue, days, platform } = this.state;

    let payload;
    try {
      payload = buildLogRetrievalRequestPayload(
        targetType,
        targetValue,
        days,
        platform,
        createLogRetrievalRequestId()
      );
    } catch (error) {
      message.warning(error.message);
      return;
    }

    this.setState({ loading: true });
    try {
      const created = await createLogRetrievalRequestApi(payload);
      message.success(`回捞工单已创建 (${created.requestId})`);
      await this.loadHistory();
    } catch (error) {
      console.error("Failed to create retrieval work item", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  columns = [
    {
      title: "创建时间",
      dataIndex: "createdAt",
      width: 180,
      render: (createdAt) => new Date(createdAt).toLocaleString("zh-CN")
    },
    {
      title: "目标",
      key: "target",
      width: 220,
      render: (_, record) => formatLogRetrievalTarget(record)
    },
    {
      title: "范围",
      key: "scope",
      width: 120,
      render: (_, record) => `${record.days} 天 / ${record.platform || "all"}`
    },
    {
      title: "状态",
      dataIndex: "status",
      width: 100,
      render: (status) => {
        const meta = logRetrievalStatusMeta(status);
        return <Tag color={meta.color}>{meta.label}</Tag>;
      }
    },
    {
      title: "回捞单 ID",
      dataIndex: "requestId",
      width: 260
    },
    {
      title: "日志任务",
      dataIndex: "taskId",
      width: 100,
      render: (taskId) => taskId > 0
        ? <a href={logRetrievalTaskHref(taskId)}>{taskId}</a>
        : "-"
    },
    {
      title: "错误",
      dataIndex: "errorMessage",
      ellipsis: true,
      render: (errorMessage) => errorMessage || "-"
    }
  ];

  render() {
    const {
      targetType,
      targetValue,
      days,
      platform,
      loading,
      historyLoading,
      history
    } = this.state;

    return (
      <Layout.Content className="push-page">
        <Card title="日志回捞" bordered={false}>
          <Form layout="inline" className="push-form">
            <Form.Item label="目标类型">
              <Select
                value={targetType}
                onChange={(value) => this.setState({ targetType: value, targetValue: "" })}
                style={{ width: 120 }}
              >
                <Option value="deviceId">设备 ID</Option>
                <Option value="userId">用户 ID</Option>
              </Select>
            </Form.Item>
            <Form.Item label={targetType === "deviceId" ? "设备 ID" : "用户 ID"}>
              <Input
                value={targetValue}
                onChange={(event) => this.setState({ targetValue: event.target.value })}
                onPressEnter={this.handleCreate}
                style={{ width: 220 }}
              />
            </Form.Item>
            <Form.Item label="回捞天数">
              <Select
                value={days}
                onChange={(value) => this.setState({ days: value })}
                style={{ width: 140 }}
              >
                {DAYS_OPTIONS.map((option) => (
                  <Option key={option.value} value={option.value}>{option.label}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="目标平台">
              <Select
                value={platform}
                onChange={(value) => this.setState({ platform: value })}
                style={{ width: 140 }}
              >
                {PLATFORM_OPTIONS.map((option) => (
                  <Option key={option.value} value={option.value}>{option.label}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" icon="cloud-download" loading={loading} onClick={this.handleCreate}>
                创建回捞工单
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Card
          title="回捞工单"
          bordered={false}
          style={{ marginTop: 16 }}
          extra={<Button type="link" icon="reload" onClick={this.loadHistory}>刷新</Button>}
        >
          <Table
            rowKey="requestId"
            columns={this.columns}
            dataSource={history}
            loading={historyLoading}
            pagination={{ pageSize: 20 }}
            size="small"
            locale={{ emptyText: "暂无回捞工单" }}
            scroll={{ x: 1120 }}
          />
        </Card>
      </Layout.Content>
    );
  }
}

export default PushPage;
